import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'app-logout',
  template: '<div class="page-layout simple fullwidth" style="background-color:#fafafa !important"></div>',
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.logout();
  }

}
